/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react';

function OfficeLocation({en_data, id_data, en_desc, id_desc, language}) {

  return (
    <>
      <div className='mt-5 mb-5'>
        <div className='col-our-office-location'>
            <div className='container'>
            <div className='row'>
                <div className='col-md-6'>
                <h2
                    className='title'
                    dangerouslySetInnerHTML={{
                    __html:
                        language === 'EN'
                        ? en_data
                        : id_data,
                    }}
                ></h2>
                <p
                    dangerouslySetInnerHTML={{
                    __html:
                        language === 'EN'
                        ? en_desc
                        : id_desc,
                    }}
                ></p>
                </div>
                <div className='col-md-6'>
                <iframe
                    src='https://www.google.com/maps/d/embed?mid=1DiYJf7yWi0eCpEenTbC2KM3bTL9of10&ehbc=2E312F'
                    width='100%'
                    height='300px'
                ></iframe>
                </div>
            </div>
            </div>
        </div>
        </div>
    </>
  );
}

export default OfficeLocation;